
import React from "react";
import AppLayout from "@/components/layout/AppLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { FileText, Info } from "lucide-react";

const AboutPage: React.FC = () => {
  return (
    <AppLayout title="À propos" showBack>
      <div className="space-y-6">
        <Card>
          <CardHeader>
            <div className="flex items-center space-x-2">
              <Info className="h-5 w-5 text-farm-dark-green" />
              <CardTitle>À propos de Bilanga Mayele</CardTitle>
            </div>
            <CardDescription>
              Informations sur l'application et sa version
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <h3 className="text-lg font-semibold mb-2">Version</h3>
              <p className="text-sm text-muted-foreground">Version 1.0.0 (Mai 2025)</p>
            </div>
            
            <Separator />
            
            <div>
              <h3 className="text-lg font-semibold mb-2">Description</h3>
              <p className="text-sm text-muted-foreground">
                Bilanga Mayele est une application de gestion agricole conçue pour aider les agriculteurs à gérer 
                efficacement leurs parcelles, observations et activités. L'application permet de suivre les 
                différentes cultures, planifier les activités agricoles et enregistrer les observations 
                sur le terrain.
              </p>
            </div>
            
            <Separator />
            
            <div>
              <h3 className="text-lg font-semibold mb-2">Fonctionnalités principales</h3>
              <ul className="text-sm text-muted-foreground space-y-1 list-disc pl-5">
                <li>Gestion des parcelles agricoles avec visualisation cartographique</li>
                <li>Suivi des observations sur les cultures et les champs</li>
                <li>Planification et gestion des activités agricoles</li>
                <li>Tableau de bord personnalisé avec résumé des informations importantes</li>
                <li>Profil utilisateur personnalisable</li>
              </ul>
            </div>
            
            <Separator />
            
            <div>
              <h3 className="text-lg font-semibold mb-2">Développé par</h3>
              <p className="text-sm text-muted-foreground">
                Bilanga Solutions © 2025. Tous droits réservés.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </AppLayout>
  );
};

export default AboutPage;
